import { Map } from 'immutable';

import {
  OPEN_PDF_VIEWER,
  SET_DASHBOARD_HEADER_INFO,
  SET_DASHBOARD_HEADER_INFO_WAITING,
  SET_UPDATE_CYCLE_MESSAGE,
} from '../../actions/dashboardActionType';
import * as t from '../../actions/userActionTypes';

const initialState = Map({
  message: '',
  showPdfViewer: false,
  dashboardHeaderInfo: null,
  dashboardHeaderInfoWaiting: false,
  setUpdateCycleMessage: { type: 'success', text: '' },
});

const reducer = function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_LOADING:
      return state.set('message', action.message);
    case OPEN_PDF_VIEWER:
      return state.set('showPdfViewer', action.value);
    case SET_DASHBOARD_HEADER_INFO:
      return state.set('dashboardHeaderInfo', action.data);
    case SET_DASHBOARD_HEADER_INFO_WAITING:
      return state.set('dashboardHeaderInfoWaiting', action.value);
    case SET_UPDATE_CYCLE_MESSAGE:
      return state.set('setUpdateCycleMessage', action.message);
    default:
      return state;
  }
};

export default reducer;
